<app-loader [loader]="loader.count" *ngIf="loader.count > 0"></app-loader>

<app-header></app-header>

<h2 class="h2 px-2">{{'PRIVACY.TITLE' | translate }}</h2>
<div class="row">
    <div class="col-sm-2 py-3"></div>
    <div class="col-sm-8 py-3">
        <p [innerHTML]="'PRIVACY.P1' | translate"></p>
        <p [innerHTML]="'PRIVACY.P2' | translate"></p>
        
        <h4>{{'PRIVACY.ARTICLE1.HEADER' | translate }}</h4>
        <p [innerHTML]="'PRIVACY.ARTICLE1.P1' | translate"></p>
        <p [innerHTML]="'PRIVACY.ARTICLE1.P2' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE1.P3' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE1.P4' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE1.P5' | translate "></p>

        <h4>{{'PRIVACY.ARTICLE2.HEADER' | translate }}</h4>
        <p [innerHTML]="'PRIVACY.ARTICLE2.P1' | translate"></p>
        <p [innerHTML]="'PRIVACY.ARTICLE2.P2' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE2.P3' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE2.P4' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE2.P5' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE2.P6' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE2.P7' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE2.P8' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE2.P9' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE2.P10' | translate "></p>

        <h4>{{'PRIVACY.ARTICLE3.HEADER' | translate }}</h4>
        <p [innerHTML]="'PRIVACY.ARTICLE3.P1' | translate"></p>
        <p [innerHTML]="'PRIVACY.ARTICLE3.P2' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE3.P3' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE3.P4' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE3.P5' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE3.P6' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE3.P7' | translate "></p>

        <h4>{{'PRIVACY.ARTICLE4.HEADER' | translate }}</h4>
        <p [innerHTML]="'PRIVACY.ARTICLE4.P1' | translate"></p>
        <p [innerHTML]="'PRIVACY.ARTICLE4.P2' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE4.P3' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE4.P4' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE4.P5' | translate "></p>

        <h4>{{'PRIVACY.ARTICLE5.HEADER' | translate }}</h4>
        <p [innerHTML]="'PRIVACY.ARTICLE5.P1' | translate"></p>
        <p [innerHTML]="'PRIVACY.ARTICLE5.P2' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE5.P3' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE5.P4' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE5.P5' | translate "></p>

        <h4>{{'PRIVACY.ARTICLE6.HEADER' | translate }}</h4>
        <p [innerHTML]="'PRIVACY.ARTICLE6.P1' | translate"></p>
        <p [innerHTML]="'PRIVACY.ARTICLE6.P2' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE6.P3' | translate "></p>
        <p [innerHTML]="'PRIVACY.ARTICLE6.P4' | translate "></p>

        <h4>{{'PRIVACY.ARTICLE7.HEADER' | translate }}</h4>
        <p [innerHTML]="'PRIVACY.ARTICLE7.P1' | translate"></p>
        <p [innerHTML]="'PRIVACY.ARTICLE7.P2' | translate "></p>
        
    </div>
</div>
<app-footer></app-footer>

